import React from 'react'
import {
  Link,
  PathMatch,
  matchPath,
  useLocation,
  useParams,
} from 'react-router-dom'

const routes = [
  '/:prospectId/',
  '/:prospectId/business',
  '/:prospectId/agreements/tesa',
  '/:prospectId/agreements/supplement',
  '/:prospectId/agreements/payment',
  '/:prospectId/finish',
]

const DemoMode = (): JSX.Element => {
  const { pathname } = useLocation()
  const { prospectId } = useParams<{ prospectId: string }>()

  const getParams = (path: string): PathMatch<string> | null =>
    matchPath(path, pathname)
  const currentRouteIndex = routes
    .map((path) => getParams(path))
    .findIndex((obj) => obj !== null)
  const getRouteByIndex = (index: number): string =>
    routes[index]?.replace(':prospectId', prospectId!)

  return (
    <div className="sticky top-0 z-10 min-h-10 w-full max-w-[1200px] text-white text-center mx-auto font-normal text-base bg-king-blue">
      <div className="grid grid-cols-[120px_auto_120px] h-full">
        {currentRouteIndex !== 0 ? (
          <Link
            to={getRouteByIndex(currentRouteIndex - 1)}
            className="border-0 bg-king-red text-white font-normal text-base py-2.5 px-0 no-underline flex flex-col justify-center hover:text-white"
          >
            <span>Previous</span>
          </Link>
        ) : (
          <div />
        )}
        <div className="self-center h-full p-2.5">Demo Mode</div>
        {currentRouteIndex !== routes.length - 1 && (
          <Link
            to={getRouteByIndex(currentRouteIndex + 1)}
            className="border-0 bg-king-red text-white font-normal text-base py-2.5 px-0 no-underline flex flex-col justify-center hover:text-white"
          >
            <span>Next</span>
          </Link>
        )}
      </div>
    </div>
  )
}

export default DemoMode
